// Imports => Constants
import { ENDPOINTS } from '@constants/endpoints.constants';

export class TermsAPI {
  constructor(Instance) {
    this.Store = Instance.Store;
    this.Client = Instance.Client;
  }

  list() {
    return this.Client.get(ENDPOINTS.TERMS.INDEX).then((response) => response.data);
  }

  single(id) {
    return this.Client.get(ENDPOINTS.TERMS.SHOW(id)).then(
      (response) => response.data
    );
  }

  getForPublication() {
    return this.list();
  }
}

export default TermsAPI;
